import kitchenInstance from './instance'

const getKitchenOrders = (page = 0, size = 10, kitchenMonitorConfigId) => {
	return kitchenInstance.get('/orders/?' + ((page || size) ? '&page=' + page + '&size=' + size : '')
		+ (kitchenMonitorConfigId ? '&kitchenMonitorConfigId=' + kitchenMonitorConfigId : '')
	)
}

export default getKitchenOrders
